/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="73.59"
        height="92.51"
        viewBox="0 0 73.59 92.51"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="m29.97 68.01 17 .35a1.25 1.25 0 0 1 1 .6l.07.13 2.9 6.29a1.25 1.25 0 0 1-2.21 1.16l-.06-.11-2.57-5.59-15.53-.32-3.25 5.47a1.25 1.25 0 0 1-1.6.5l-.12-.06a1.24 1.24 0 0 1-.49-1.59l.06-.13 3.63-6.09a1.24 1.24 0 0 1 1-.61ZM32.17 10.41a1.25 1.25 0 0 1 1.61.44l.07.12L58.9 60.76A1.25 1.25 0 0 1 56.73 62l-.06-.11-25.06-49.8a1.25 1.25 0 0 1 .56-1.68Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M60.59 60.07a1.24 1.24 0 0 1 1.25 1.25 1.26 1.26 0 0 1-1.12 1.25h-28a1.25 1.25 0 0 1-.12-2.49h28Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M33.28 4.8a1.24 1.24 0 0 1-.34 1.63l-.2.13-.23.14-.54.33-.41.27c-1 .67-2.19 1.47-3.44 2.4a77.09 77.09 0 0 0-10.44 9.38C5.43 32.34-.32 47.96 3.94 65.73l.06.26.29-.12c1.33-.55 2.84-1.1 4.51-1.62a48.22 48.22 0 0 1 23.58-1.53 1.26 1.26 0 0 1 1 1.47 1.25 1.25 0 0 1-1.47 1 45.72 45.72 0 0 0-22.35 1.47c-1.6.49-3 1-4.29 1.54l-.5.21-.45.2-.53.25a1.24 1.24 0 0 1-1.77-.79c-5.29-19.41.71-36.42 13.89-50.69a78.94 78.94 0 0 1 10.67-9.69q1.7-1.26 3.15-2.22l.64-.41.41-.27.64-.39.11-.06a1.24 1.24 0 0 1 1.75.46Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M28.36 6.62a1.254 1.254 0 0 1 2.3 1c-5.51 12.82-7.9 23.75-7.7 33 .15 7.11 1.83 12.79 4.52 17.17a20.89 20.89 0 0 0 3.06 3.94c.28.29.55.53.79.74l.35.29.15.11a1.25 1.25 0 1 1-1.41 2.06l-.1-.07-.24-.18a14 14 0 0 1-1.31-1.18 23.57 23.57 0 0 1-3.42-4.4c-6.93-11.35-7.29-28.5 3.01-52.48Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M38.75 0a1.24 1.24 0 0 1 1.24 1.12v2.23h5.36a1.24 1.24 0 0 1 1.24 1.12v.13a1.24 1.24 0 0 1-1.12 1.24h-6.72a1.24 1.24 0 0 1-1.24-1.12V2.5h-3.75v66.69a1.26 1.26 0 0 1-1.12 1.25h-.13a1.24 1.24 0 0 1-1.23-1.12V1.25A1.24 1.24 0 0 1 32.4.01h6.37ZM4.11 73.37l.45.08.39.06.64.08.75.07 1.1.1 1.56.11 1.79.1 1.33.07 2.57.11 3.76.14 4.73.14 4.18.11 5.12.11 4.85.09 3.75.06h3.8l3.84.05 6.64.07 8.66.07a1.25 1.25 0 0 1 1.11.69l.05.12 4.8 12.76a1.25 1.25 0 0 1-2.29 1l-.06-.12-4.49-12-8.63-.07-5.82-.06-5.76-.08-5.65.02-5.7-.11-3.88-.08-4.21-.11-3.86-.11-3-.1-1.86-.07-2.94-.13-1.86-.1-1.65-.1-1.17-.09h-.29c.53.62 1.11 1.28 1.75 2l.38.42a87.82 87.82 0 0 0 12 10.64 1.25 1.25 0 0 1-1.49 2A90.82 90.82 0 0 1 7.16 80.37q-1.63-1.74-2.85-3.23l-.48-.59-.33-.42-.37-.47-.21-.28a1.25 1.25 0 0 1 1.19-2.01Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M71.6 85.89a1.25 1.25 0 1 1 1.48 2c-7.76 5.7-15 5.7-21.15 2.23a18.27 18.27 0 0 1-2.27-1.49l-.24-.2-.37.25c-7.21 4.81-14 4.74-19.73 1.61l-.3-.17a18.08 18.08 0 0 1-2.26-1.49l-.25-.2-.37.25c-7.21 4.81-14 4.74-19.73 1.61l-.3-.17a15.13 15.13 0 0 1-3.24-2.36A1.252 1.252 0 1 1 4.65 86l.12.12.17.15.23.2.14.11a16.26 16.26 0 0 0 2 1.37c5.32 3 11.53 3 18.45-2.08a1.34 1.34 0 0 1 .58-.23h.3a1.3 1.3 0 0 1 .89.37l.11.12.18.15.23.2.14.11a16.26 16.26 0 0 0 2 1.37c5.31 3 11.53 3 18.44-2.08a1.44 1.44 0 0 1 .58-.23h.3a1.26 1.26 0 0 1 .89.37l.12.12.17.15.23.2.14.11a15.7 15.7 0 0 0 2 1.37c5.41 3 11.63 3 18.54-2.08Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'SailboatOnWaterIcon';

export default Icon;
